/* eslint-disable */

import {useCallback, useEffect, useRef} from "react"
import parallaxStyles from "components/homeParallax/HomeParallax.module.scss";
import {scrollToElement} from "utils/Helpers";

const GrabToScroll = (props) => {

    const isDown = useRef(false);
    const startX = useRef();
    const scrollLeft = useRef();
    const velX = useRef(0);
    const momentumID = useRef();

    const mouseDown = useCallback((e)=>{
        isDown.current = true;
        props.stage.current.classList.add('active');
        props.stage.current.classList.remove(parallaxStyles.snapType)
        props.stage.current.style.scrollSnapType = '';
        props.stage.current.style.msScrollSnapType = '';
        startX.current = e.pageX - props.stage.current.offsetLeft;
        scrollLeft.current = props.stage.current.scrollLeft;
        cancelMomentumTracking();
    }, [])

    const mouseLeave = useCallback(()=>{
        isDown.current = false;
        props.stage.current.classList.remove('active');
    }, [])

    const mouseUp = useCallback(()=>{
        isDown.current = false;
        props.stage.current.classList.remove('active');
        beginMomentumTracking();
    },[])

    const mouseMove = useCallback((e)=>{
        if(!isDown.current) return;
        e.preventDefault();
        const x = e.pageX - props.stage.current.offsetLeft;
        const walk = (x - startX.current) * 3; //scroll-fast
        let prevScrollLeft = props.stage.current.scrollLeft;
        props.stage.current.scrollLeft = scrollLeft.current - walk;
        velX.current = props.stage.current.scrollLeft - prevScrollLeft;
    }, [])

    useEffect(()=>{

        props.stage.current.addEventListener('mousedown', mouseDown);
        props.stage.current.addEventListener('mouseleave', mouseLeave);
        props.stage.current.addEventListener('mouseup', mouseUp);
        props.stage.current.addEventListener('mousemove', mouseMove);
        props.stage.current.addEventListener('wheel', cancelMomentumTracking());

        return ()=>{
            props.stage.current.removeEventListener('mousedown', mouseDown);
            props.stage.current.removeEventListener('mouseleave', mouseLeave);
            props.stage.current.removeEventListener('mouseup', mouseUp);
            props.stage.current.removeEventListener('mousemove', mouseMove);
            props.stage.current.removeEventListener('wheel', cancelMomentumTracking());
        }

    }, [mouseDown,mouseLeave])


    function beginMomentumTracking(){
        cancelMomentumTracking();
        momentumID.current = requestAnimationFrame(momentumLoop);
    }
    function cancelMomentumTracking() {
        cancelAnimationFrame(momentumID.current);
    }

    function momentumLoop() {

        props.stage.current.scrollLeft += velX.current;
        velX.current *= 0.95;
        if (Math.abs(velX.current) > 5) {
            momentumID.current = requestAnimationFrame(momentumLoop);
        } else {

            let foundNode = null;
            props.stage.current.childNodes.forEach((node) => {
                if(node && node.offsetParent){
                    let point = node.getBoundingClientRect().width / 2
                    let offsetLeft = node.getBoundingClientRect().left - node.offsetParent.getBoundingClientRect().left;
                    if (Math.abs(offsetLeft) < point) foundNode = node;
                }

            })

            if(foundNode){
                scrollToElement(foundNode, 'x', null, () => {
                    props.scrollPos.current = props.stage.current.scrollLeft;
                    props.scrollReset()
                })
            } else {
                props.scrollPos.current = props.stage.current.scrollLeft;
                props.scrollReset()
            }

        }
    }

    return <></>;

}

export default GrabToScroll;